export const mockHeaderMenuItems = [
  {
    itemName: 'panel.header.title.postings',
    icon: 'misAvisos',
    path: 'panel.header.url.postings',
    alternativePath: ['/desempeno', '/contactos-permisos'],
    external: false
  },
  {
    itemName: 'panel.header.title.interested',
    icon: 'interested',
    path: 'panel.header.url.interested',
    external: false
  },
  {
    itemName: 'panel.header.title.statistics',
    icon: 'stats',
    path: 'panel.header.url.statistics',
    external: false
  },
  {
    itemName: 'panel.header.title.statistics',
    icon: 'statsNoIcon',
    path: 'panel.header.url.statistics',
    external: false
  },
  {
    itemName: 'panel.header.title.activity',
    icon: 'activity',
    path: 'panel.header.url.activity',
    external: false
  },
  {
    itemName: 'panel.header.title.payments',
    icon: 'contracts',
    path: 'panel.header.url.payments',
    external: true,
    border: ['particular']
  },
  {
    itemName: 'panel.header.title.realestate',
    icon: 'realEstate',
    path: 'panel.header.url.realestate',
    external: false
  },
  {
    itemName: 'panel.header.title.realestate',
    icon: 'realEstateBranch',
    path: 'panel.header.url.realestateBranch',
    external: true
  },
  {
    itemName: 'panel.header.title.assessments',
    icon: 'assessments',
    path: 'panel.header.url.assessments',
    external: true
  },
  {
    itemName: 'panel.header.title.messages',
    icon: 'messages',
    path: 'panel.activity.url.messages',
    external: false
  },
  {
    itemName: 'panel.header.title.favorites',
    icon: 'favorites',
    path: 'panel.header.url.favorites',
    external: false
  },
  {
    itemName: 'panel.header.title.savedSearches',
    icon: 'savedSearches',
    path: 'panel.activity.url.savedSearches',
    external: false
  },
  {
    itemName: 'panel.activity.viewed.MainTitle',
    icon: 'viewed',
    path: 'panel.activity.url.viewed',
    external: false,
    border: ['seeker', 'publisher']
  },
  {
    itemName: 'panel.header.title.account',
    icon: 'user',
    path: 'panel.header.url.account',
    external: false,
    border: ['publisher']
  },
  {
    itemName: 'panel.header.title.account',
    icon: 'userNoIcon',
    path: 'panel.header.url.account',
    external: false
  },
  {
    itemName: 'panel.configuration.subscriptions.MainTitle',
    icon: 'notifications',
    path: 'panel.configuration.url.subscriptions',
    external: false,
    border: ['seeker', 'particular']
  },
  {
    itemName: 'panel.header.subtitle.manage',
    icon: 'manage',
    subtitle: true,
    border: ['publisher']
  },
  {
    itemName: 'panel.header.title.activity',
    icon: 'myActivity',
    subtitle: true
  }
];

const seekerItems = {
  navbar: ['activity', 'user'],
  dropdown: ['messages', 'favorites', 'savedSearches', 'viewed', 'userNoIcon', 'notifications', 'assessments']
};
const particularItems = {
  navbar: ['misAvisos', 'interested', 'activity', 'contracts'],
  dropdown: ['misAvisos', 'interested', 'activity', 'contracts', 'assessments', 'userNoIcon', 'notifications']
};
const publisherItems = {
  navbar: ['misAvisos', 'interested', 'stats'],
  dropdownAdmin: [
    'manage',
    'contracts',
    'realEstate',
    'assessments',
    'user',
    'myActivity',
    'messages',
    'favorites',
    'savedSearches',
    'viewed'
  ],
  dropdown: [
    'manage',
    'contracts',
    'realEstateBranch',
    'assessments',
    'user',
    'myActivity',
    'messages',
    'favorites',
    'savedSearches',
    'viewed'
  ],
  mobileAdmin: [
    'manage',
    'misAvisos',
    'interested',
    'stats',
    'contracts',
    'realEstate',
    'assessments',
    'user',
    'myActivity',
    'messages',
    'favorites',
    'savedSearches',
    'viewed'
  ],
  mobile: [
    'manage',
    'misAvisos',
    'interested',
    'stats',
    'contracts',
    'realEstateBranch',
    'assessments',
    'user',
    'myActivity',
    'messages',
    'favorites',
    'savedSearches',
    'viewed'
  ]
};

export const getSeekerItems = type =>
  seekerItems[type].map(item => mockHeaderMenuItems.find(link => link.icon === item));
export const getParticularItems = type =>
  particularItems[type].map(item => mockHeaderMenuItems.find(link => link.icon === item));
export const getPublisherItems = type =>
  publisherItems[type].map(item => mockHeaderMenuItems.find(link => link.icon === item));
